import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SubmissionRecord from "./SubmissionRecord/SubmissionRecord";
import BankSubmissionFile from "./BankSubmissionFile/BankSubmissionFile";
import s from "./BankSubmission.module.scss";
import SubmissionConfiguration from "./SubmissionConfiguration/SubmissionConfiguration";
import ButtonMAS from "ButtonMAS/ButtonMAS";

const BankSubmission = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectTab] = useState("submissionRecord");

  const changeSelectedTab = (innerTabName) => {
    setSelectTab(innerTabName);
  };

  const innerTabContainer = () => {
    return (
      <div className={s.innerTabBox}>
        <div
          className={[
            s.innerTab,
            selectedTab === "submissionRecord" ? s.selectedTab : "",
          ].join(" ")}
        >
          <ButtonMAS
            variant="text-only"
            onClick={() => changeSelectedTab("submissionRecord")}
          >
            <span>
              {t("page.finance.bankSubmission.innerTab.submissionRecord.label")}
            </span>
          </ButtonMAS>
        </div>
        <div
          className={[
            s.innerTab,
            selectedTab === "bankSubmissionFile" ? s.selectedTab : "",
          ].join(" ")}
        >
          <ButtonMAS
            variant="text-only"
            onClick={() => changeSelectedTab("bankSubmissionFile")}
          >
            <span>
              {t(
                "page.finance.bankSubmission.innerTab.bankSubmissionFile.label",
              )}
            </span>
          </ButtonMAS>
        </div>
        <div
          className={[
            s.innerTab,
            selectedTab === "submissionConfiguration" ? s.selectedTab : "",
          ].join(" ")}
        >
          <ButtonMAS
            variant="text-only"
            onClick={() => changeSelectedTab("submissionConfiguration")}
          >
            <span>
              {t(
                "page.finance.bankSubmission.innerTab.submissionConfiguration.label",
              )}
            </span>
          </ButtonMAS>
        </div>
      </div>
    );
  };

  const renderSelectedPage = () => {
    switch (selectedTab) {
      case "submissionRecord":
        return <SubmissionRecord />;
      case "bankSubmissionFile":
        return <BankSubmissionFile />;
      case "submissionConfiguration":
        return <SubmissionConfiguration />;
    }
  };

  return (
    <div className={s.container}>
      <div className={s.innerTabContainer}>{innerTabContainer()}</div>

      <div className={s.contentContainer}>{renderSelectedPage()}</div>
    </div>
  );
};

export default React.memo(BankSubmission);
